import React from 'react';
import { Spin } from 'antd';

import './style.scss';

function Loading() {
  return (
    <div className='loading-page'>
      <Spin tip="Loading..." />
    </div>
  );
}

export default Loading;